import i18n from 'i18n';

export const translate = (key: string, options?: { [key: string]: string | number }) => i18n.t(key, options || {});
